import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import "./MainHeader.modules.css";

import { TopNavbar } from "./TopNavbar";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useContext, useState,  useEffect } from "react";
import AuthContext from "../../context/user-auth/AuthProvider";
import TokenService from "../../api/token.service";
import Cookies from "js-cookie";
import Profile from "../modals/Profile/Profile";
import ResetPass from "../modals/reset_password/ResetPass";

function MainHeader() {
  const location = useLocation();
  const [newUserState, setNewUserState] = useState(false);
  const UserState = async () => {
    if(!location?.state?.newUser)
      {
        getApplicationIds();
      }
      setNewUserState(location.state.newUser)
  }
  const { dispatch, userDetails, getUserDetails, getApplicationIds,updateMfaAuthentication, } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [profilePopup,setProfilePopup]=useState(false);
  const handleCloseProfile = () =>{setProfilePopup(false);}
  const handleShow = () => setProfilePopup(true);

  const navigate = useNavigate();

  const logout = async () => {
    dispatch({ type: "GET_APPLICATION_DETAILS", payload: [] });
    dispatch({ type: "USER_LOGOUT" });
    TokenService.removeUser();
    navigate("/login");
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    getUserDetails();
    
    UserState();

    if (!Cookies.get("userAuthToken")) {
      Cookies.set("userAuthToken", localStorage.getItem("userAuthToken"), { path: "/" });
    }
  }, []);

  return (
    <>
      <header>
        <TopNavbar Link={Link} />
        <Navbar expand="lg" className="navbarDarkTheme">
          <Container fluid>
            <Link to="/" className="navbar-brand text-white fw-bold">
              DCTS
              <p className="fw-normal fs-6 mb-0">Supplier Management System</p>
            </Link>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <div className="ms-auto d-flex align-items-center position-relative">
                {!userDetails?.first_name ? (
                  <p className="mb-0 placeholder-glow" aria-hidden="true" style={{ width: "10rem" }}>
                    <span className="placeholder col-12 bg-light"></span>
                  </p>
                ) : (
                  <p className="mb-0 fw-bold text-white">{`${userDetails?.first_name} ${userDetails?.last_name}`}</p>
                )}

                <div>
                  <IconButton size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleMenu} className="text-white">
                    <AccountCircle />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    <MenuItem onClick={handleShow}>My Profile</MenuItem>
                    <MenuItem onClick={logout}>Logout</MenuItem>
                  </Menu>
                </div>
              </div>
              <div className="d-flex">
                <Dropdown className="d-none d-sm-block">
                  <Dropdown.Toggle variant="success" id="accountDetail">
                    {/* <FaRegUserCircle /> */}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-end accountDropdown border-0 shadow-lg" style={{ width: "14rem" }}>
                    <div className="dropdown-header noti-title">
                      <h6 className="text-overflow m-0">Minimal UI</h6>
                      <p className="mb-0 text-muted">demo@minimals.cc</p>
                    </div>
                    {/* <Dropdown.Item href="#/action-1">
                      <Button>
                        My Profile
                        </Button>
                        </Dropdown.Item> */}
                    <Dropdown.Item href="#/action-2">Settings</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item href="#/action-3">
                      <Button>Logout</Button>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>

     
      
      {newUserState ? <ResetPass /> :  <main id="main_wrapper" className="mt-3" style={{ minHeight: "80vh", paddingBottom: "3rem" }}>
        <Outlet />
      </main>}
      
      <Profile show={profilePopup} onhide={handleCloseProfile} userdetails={userDetails} updateMfaAuthentication={updateMfaAuthentication} getUserDetails={getUserDetails} logout={logout} />
    </>

  );
}

export default MainHeader;
